import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OutlookStore } from '../state';
import { ConfigurationSetting } from '@maximizer/core/shared/domain';
import { catchError, Observable, of, tap } from 'rxjs';
import { ConfigurationService } from '@maximizer/core/shared/data-access';
import { mapDatabaseVerticalToEnum } from '../utils';

@Injectable()
export class VerticalService {
  private readonly translate = inject(TranslateService);
  private readonly outlookStore = inject(OutlookStore);
  private readonly configurationService = inject(ConfigurationService);

  getDatabaseVertical(): Observable<ConfigurationSetting | null> {
    return this.configurationService
      .getSetting({ code3: 'DATABASE_VERTICAL' })
      .pipe(
        tap((result) => {
          if (result) {
            const verticalEnum = mapDatabaseVerticalToEnum(result.textValue);
            this.outlookStore.updateVertical(verticalEnum);
          }
        }),
        catchError((error) => {
          console.error(error, 'Failed to get database vertical');
          return of(null);
        }),
      );
  }

  translateVertical(key: string): string {
    const vertical = this.outlookStore.vertical();
    return this.translate.instant(`outlook.entries.${vertical}.${key}`);
  }
}
